import React from "react";
import "./ticketDetail.style";
import { Grid } from '@mui/material';
import parse from 'html-react-parser';
import HyperLink from "../../commonComponents/hyperLink/hyperLink";
import { NOT_APPLICABLE } from '../../../constants/originalState';
import { DISPATCH_MODE } from "../constant";

export interface IAssignmentErrorProps {
  infoTicket: any,
  KBPcCost: any,
  configTracking: any,
  locale: any
};

const NewDevice = (props: IAssignmentErrorProps) => {
  const { infoTicket, KBPcCost, configTracking, locale } = props;
  const { variables, approvers, delegate_managers } = infoTicket;
  const { json_storage } = variables;
  const conditionDelegatedApprovalRequests = delegate_managers && !!delegate_managers[0]?.delegate?.email && variables?.stage?.value === "awaiting_approval" && infoTicket?.state === "Open";
  return (
    <>
      <Grid container>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.requestorName}</p>
          <p className="value-info" id="lbl-newdevice-requestor_name">{json_storage?.requestor_name ? json_storage?.requestor_name: NOT_APPLICABLE}</p>
        </Grid>
        <Grid item xs={6}>
          <p className="ttl-col-desc">{locale?.requestorEmail}</p>
          <p className="value-info" id="lbl-newdevice-requestor_email">{json_storage?.requestor_email ? json_storage?.requestor_email: NOT_APPLICABLE}</p>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.recipientName}</p>
          <p className="value-info" id="lbl-newdevice-recipient_name">{json_storage?.recipient_name ? json_storage?.recipient_name: NOT_APPLICABLE}</p>
        </Grid>
        <Grid item xs={6}>
          <p className="ttl-col-desc">{locale?.recipientEmail}</p>
          <p className="value-info" id="lbl-newdevice-user_email">{json_storage?.user_email ? json_storage?.user_email: NOT_APPLICABLE}</p>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.workerType}</p>
          <p className="value-info" id="lbl-newdevice-employee_type">{json_storage?.employee_type ? json_storage?.employee_type : NOT_APPLICABLE}</p>
        </Grid>
        <Grid item xs={6}>
          <p className="ttl-col-desc">{locale?.reason_for_approval}</p>
          <p className="value-info" id="lbl-newdevice-request_context">{!!json_storage?.request_context ? json_storage?.request_context : NOT_APPLICABLE }</p>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.costCenter}</p>
          <p className="value-info" id="lbl-newdevice-cost_center">{!!json_storage?.cost_center ? json_storage?.cost_center : NOT_APPLICABLE }</p>
        </Grid>
        <Grid item xs={6}>
          <p className="ttl-col-desc">{locale?.pc_exception_faq}</p>
          <p className="value-info" id="lbl-newdevice-pc_exception_faq">
            <HyperLink
              label={locale?.clickHere}
              onClick={() => window.open(`/knowledge/detail/${KBPcCost}`, '_blank')}
              id="lnk-newdevice-click_here"
            />
          </p>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{conditionDelegatedApprovalRequests? locale?.managerInfomation : locale?.approverInfo}</p>
          <p className="value-info" id="lbl-newdevice-approver_email">{!!json_storage?.approver_email ? json_storage?.approver_email : NOT_APPLICABLE}</p>
        </Grid>
        {conditionDelegatedApprovalRequests &&
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.managerDelegatedInfo}</p>
          <p className="value-info" id="lbl-newdevice-managerdelegatedinfo">{delegate_managers[0]?.delegate?.email}</p>
        </Grid>}
      </Grid>
      {approvers?.map((items: any) => items.state === 'Rejected' ?
        <Grid container>
          <Grid item xs={6}>
            <p className="ttl-col-desc">{locale?.business_justification_comments}</p>
            <p className="value-info" id="lbl-newdevice-business_justification_comments">{parse(json_storage?.business_justification || '')}</p>
          </Grid>
          <Grid item xs={6} className="pr-20">
            <p className="ttl-col-desc">{locale?.rejectComment}</p>
            <p className="value-info" id="lbl-newdevice-rejectcomment">{ items.comments[0].comment }</p>
          </Grid>
        </Grid>
        :
        <Grid container>
          <Grid item xs={12}>
            <p className="ttl-col-desc">{locale?.business_justification_comments}</p>
            <p className="value-info" id="lbl-newdevice-business_justification_comments">{parse(json_storage?.business_justification || '')}</p>
          </Grid>
        </Grid>
      )}
      <Grid container>
        <Grid item xs={12}>
          <p className="ttl-col-desc">{locale?.requestedDevice}</p>
          <p className="value-info" id="lbl-newdevice-new_asset_model">
            <strong>{locale?.modelName}:</strong> {infoTicket?.requestedModel?.name || variables?.json_storage?.user_device_profile || variables?.json_storage?.new_device_model_name || NOT_APPLICABLE}
          </p>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{json_storage?.new_device_dispatch_mode === DISPATCH_MODE.PICKUP_FROM_DEPOT ? locale?.pickUpAddress : locale?.shippingAddress}</p>
          <p className="value-info value-replacement" id="lbl-newdevice-delivery_address">
            {!!variables?.delivery_address ? variables?.delivery_address : NOT_APPLICABLE}
          </p>
        </Grid>
        <Grid item xs={6}>
          <p className="ttl-col-desc">{locale?.trackingInfo}</p>
          <p className="value-info" id="lbl-newdevice-delivery_ref">
            {configTracking(variables?.delivery_ref)}
          </p>
        </Grid>
      </Grid>
      {json_storage?.starting_date &&
        <Grid container>
          <Grid item xs={6}>
            <p className="ttl-col-desc">{locale?.starting_date}</p>
            <p className="value-info" id="lbl-newdevice-starting_date">{json_storage?.starting_date || NOT_APPLICABLE}</p>
          </Grid>
        </Grid>
      }
      {json_storage?.personal_email &&
        <Grid container>
          <Grid item xs={6}>
            <p className="ttl-col-desc">{locale?.personal_email}</p>
            <p className="value-info" id="lbl-newdevice-personal_email">{json_storage?.personal_email || NOT_APPLICABLE}</p>
          </Grid>
        </Grid>
      }
    </>
  );
};

export default NewDevice;
